import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';
import { WidgetService } from 'src/app/services/widget.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { LLMWorkflowService } from 'src/app/services/llmworkflow.service';
import { DialogService } from '../../../services/dialog.service';

@Component({
    selector: 'app-llmworkflows-widget',
    templateUrl: './llmworkflows-widget.component.html',
    styleUrls: ['../base-widget/base-widget.component.scss', './llmworkflows-widget.component.scss'],
    standalone: false
})
export class LLMWorkflowsWidgetComponent extends BaseWidgetComponent implements OnInit, AfterViewInit {
  private dialogs = inject(DialogService);

  @Output() onEditFile = new EventEmitter<{ path: any }>();
  @Output() onEditWorkflow = new EventEmitter<{ name: any; path?: any }>();

  public path: string;
  public fileType: string;
  public title: string = null;
  public selectedDataset: string = null;
  public filterText = null;
  public dataSource = new MatTableDataSource<any>([]);
  @Input() displayedColumns: string[] = ['name', 'description', 'lastModified', 'actions'];
  public availableColumns = ['host', 'name', 'path', 'description', 'lastModified', 'tags', 'user'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('dataTable') dataTable!: ElementRef;
  public pageSize = 10;

  public right = 80;
  public left = 20;
  public isLoading: boolean = true;

  constructor(
    private _widgetService: WidgetService,
    private _llm: LLMWorkflowService,
    private _elRef: ElementRef
  ) {
    super();
    (<any>window).jobs = this;
  }

  ngOnInit(): void {
    this._subs.add = this._widgetService.resize$.subscribe((response) => {
      setTimeout(() => {
        try {
          this.optimizePageSize();
        } catch {}
      }, 100);
    });

    this.load();

  }

  private load() {
    this.isLoading = true;
    this._llm.load(this.teamName).subscribe((response) => {

      const dateFields = ['created', 'lastModified'];
      response.forEach((row) => {
        dateFields.forEach((field) => {
          row[field] = new Date(row[field] * 1000);
        });
      });

      this.dataSource.data = <any[]>response;
      this.optimizePageSize();
      this.isLoading = false;
    });
  }

  public reloadData() {
    this.isLoading = true;
    this.load();
  }

  public ngAfterViewInit(): void {
    this.applyTableSettings();

  }

  applyTableSettings() {
    setTimeout(() => {
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.optimizePageSize();
    }, 0);
  }

  public optimizePageSize(): void {
    let offsetHeight = this._elRef.nativeElement.offsetHeight;

    const oldPageSize = this.pageSize;
    const calcuatedPageSize = Math.floor(0.0125 * offsetHeight);
    if (calcuatedPageSize < 5) {
      this.pageSize = 5;
    } else {
      this.pageSize = calcuatedPageSize;
    }

    if (oldPageSize !== this.pageSize) {
      setTimeout(() => this.paginator._changePageSize(this.pageSize), 100);
    }
  }


  onViewData(input: any) {
    this.path = input.path;
    this.fileType = input.fileType;
    this.title = input.path.split('/').pop();
    this.widgetView = 'DETAIL';
    this.right = 100;
    this.left = 0;
  }

  onSelect(item: any) {
    const name = item.name;
    console.log(item);

    if(item.path.endsWith(".py")) {
      this.onEditFile.emit( { "path": item.path } )
    }
    else if(item.path.endsWith(".json")) {
      this.onEditWorkflow.emit({name, path: item.path});
    }
  }


  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) this.dataSource.paginator.firstPage();
  }


  close() {
    if (this.widgetView === 'DETAIL') {
      this.path = null;
      this.fileType = null;
      this.title = null;
      this.widgetView = 'LIST';
      this.right = 80;
      this.left = 20;

    } else {
      super.close();
    }
  }

  async duplicate(row, $event) {
    $event.stopPropagation();
    await this._llm.duplicateAsync(this.teamName, row.name);
    await this.load();
  }

  async delete(row, $event) {
    $event.stopPropagation();
    if (!await this.dialogs.confirm(`Are you sure you want to delete this ${row.name}?`)) return;

    this.dataSource.data = this.dataSource.data.filter((x) => x.name !== row.name);
    const sub = this._llm.remove(this.teamName, row.name).subscribe((results) => {
      sub.unsubscribe();
    });
  }


  async onDeleteDataset($event, item) {
    if (!await this.dialogs.confirm(`Are you sure want to delete command ${item}?`)) {
      return;
    }

    $event.stopPropagation();
    this.onSelect(null);
  }

  displayDescription(row): string {
    return row === undefined ||
      row === null ||
      row.description === undefined ||
      row.description === null ||
      typeof row.description !== 'string'
      ? ''
      : row.description.slice(0, 30);
  }

  add() {
    this.onEditWorkflow.emit({ name: 'add' });
  }

}
